import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.001 28.001"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.385,11.847a7.26,7.26,0,0,0-2.213-5.326,7.263,7.263,0,0,0-5.326-2.214A7.259,7.259,0,0,0,6.52,6.52a7.259,7.259,0,0,0-2.213,5.326A7.264,7.264,0,0,0,6.52,17.172a7.259,7.259,0,0,0,5.326,2.213,7.257,7.257,0,0,0,5.326-2.213A7.268,7.268,0,0,0,19.385,11.847Zm8.616,14A2.184,2.184,0,0,1,25.847,28a2,2,0,0,1-1.514-.639l-5.772-5.755a11.523,11.523,0,0,1-6.714,2.087,11.637,11.637,0,0,1-4.6-.934,11.6,11.6,0,0,1-6.31-6.31,11.8,11.8,0,0,1,0-9.2A11.6,11.6,0,0,1,7.244.934a11.8,11.8,0,0,1,9.2,0,11.6,11.6,0,0,1,6.31,6.31,11.623,11.623,0,0,1,.934,4.6,11.521,11.521,0,0,1-2.087,6.714l5.772,5.772A2.061,2.061,0,0,1,28,25.847Z",
  fill: "inherit"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}